/**
 * Textos do cartão da definição matemática em tela cheia (D4, ORD-F-078/082; src/features/hero/MathDecisionCard.tsx).
 * **PARA APROVAR** pelo responsável: sem a aprovação, a chave `features.math_card` fica desligada no ar.
 *
 * O título NÃO é novo: é a chave aprovada `headline.elected` ("{X} é {eleito:X} presidente"), a mesma do herói no estado
 * `decided` (H6, §13.2: `decided` e `elected_tse` compartilham o texto; só o chip distingue). O subtítulo também não: é
 * `event.mathDecision.overlaySub`, o da TV (§12.4). O que distingue o cartão do "Eleito · TSE" (regra 3 do CLAUDE.md) é a
 * linha de cima, "Conta dos votos · {HHhMM}" (ORD-F-152), e o cartão nunca abre com o resultado do TSE já publicado.
 * 13 à esquerda e 22 à direita, com o mesmo peso; nada projetivo; número só do TSE.
 */
import { interpolate } from './strings';

export const MATH_CARD_STRINGS = {
  'mathCard.kicker': 'Conta dos votos · {HHhMM}',
  'mathCard.sides.aria': 'Percentual de votos válidos de cada candidatura, pelo TSE',
  'mathCard.source': 'Votos válidos · Fonte: TSE',
  // o texto que o botão Compartilhar do FRONT-2 vai passar a `share()` (o botão ainda não existe)
  'mathCard.share.text': '{TITLE}. Conta dos votos · {HHhMM}. {A} {pA} · {B} {pB}. Fonte: TSE.',
} as const;
export type MathCardKey = keyof typeof MATH_CARD_STRINGS;

export function tMathCard(key: MathCardKey, vars: Record<string, string | number> = {}): string {
  return interpolate(key, MATH_CARD_STRINGS[key], vars);
}
